import React from 'react';
import SnippetBox from '../../../components/SnippetBox';
import { PricingPage } from '../../../types/pricingPage';
import { getCheckoutFnSnippet, getCheckoutSnippet, getPageSnippet, needsCheckoutSnippet } from './CopySnippet';

interface Props {
    page: PricingPage;
}

export default function SnippetPanel({ page }: Props) {
    const pageSnippet = getPageSnippet(page);
    const checkoutSnippet = getCheckoutSnippet(page);
    const checkoutFnSnippet = getCheckoutFnSnippet(page);
    const showCheckoutSnippet = needsCheckoutSnippet(page.plans);
    return (
        <div className="text-center">
            <h3 className="text-xl text-primary-normal font-bold pt-2 pb-4">Code Snippets</h3>
            <div className="pb-2">
                <div className="text-xs text-gray-700 underline">Pricing Page</div>
                <div className="text-xs text-gray-700 pb-2">
                    Copy snippet into html <strong>body</strong> tag.
                </div>
                <SnippetBox snippet={pageSnippet} />
            </div>
            {showCheckoutSnippet && (
                <>
                    <div className="pb-2">
                        <div className="text-xs text-gray-700 underline">Checkout Page</div>
                        <div className="text-xs text-gray-700 pb-2">
                            Copy snippet into html <strong>head</strong> tag.
                        </div>
                        <SnippetBox snippet={checkoutSnippet} />
                    </div>
                    <div className="pb-2">
                        <div className="text-xs text-gray-700">
                            Copy snippet into html <strong>body</strong> tag.
                        </div>
                        <SnippetBox snippet={checkoutFnSnippet} />
                    </div>
                </>
            )}
        </div>
    );
}
